import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import headerMain from "./headerMain.json";
import footer from "./footer.json";
import hospitalLogin from "./hospitalLogin.json";
import common from "./common.json";
import main from "./main.json";
import join from "./join.json";
import terms from "./terms.json";
import findAccount from "./findAccount.json";
import myReservation from "./myReservation.json";
import treatmentList from "./treatmentList.json";
import treatmentDetail from "./treatmentDetail.json";
import clinicDetail from "./clinicDetai.json";
import chatModal from "./chatModal.json";
import myPage from "./myPage.json";
import mobileNavigation from "./mobileNavigation.json";
import companyInfo from "./companyInfo.json";
import resetPw from "./resetPw.json";
import paymentModal from "./paymentModal.json";
import order from "./order.json";
import orderSuccess from "./orderSuccess.json";
import termsOfUse from "./termsOfUse.json";
import privacyOfPolicy from "./privacyOfPolicy.json";
import termsDetail from "./termsDetail.json";
import logoutConfirm from "./logoutConfirm.json";
import commercialTransactions from "./commercialTransactions.json"
import paymentCancelModal from "./paymentCancelModal.json";

const savedLanguage = localStorage.getItem("selectedLanguage") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        headerMain: headerMain.en,
        footer: footer.en,
        hospitalLogin: hospitalLogin.en,
        common: common.en,
        main: main.en,
        join: join.en,
        terms: terms.en,
        findAccount: findAccount.en,
        myReservation: myReservation.en,
        treatmentList: treatmentList.en,
        treatmentDetail: treatmentDetail.en,
        clinicDetail: clinicDetail.en,
        chatModal: chatModal.en,
        myPage: myPage.en,
        mobileNavigation: mobileNavigation.en,
        companyInfo: companyInfo.en,
        resetPw: resetPw.en,
        paymentModal: paymentModal.en,
        order: order.en,
        orderSuccess: orderSuccess.en,
        termsOfUse: termsOfUse.en,
        privacyOfPolicy: privacyOfPolicy.en,
        termsDetail: termsDetail.en,
        logoutConfirm: logoutConfirm.en,
        commercialTransactions: commercialTransactions.en,
        paymentCancelModal: paymentCancelModal.en,
      },
    },
    zh: {
      translation: {
        headerMain: headerMain.zh,
        footer: footer.zh,
        hospitalLogin: hospitalLogin.zh,
        common: common.zh,
        main: main.zh,
        join: join.zh,
        terms: terms.zh,
        findAccount: findAccount.zh,
        myReservation: myReservation.zh,
        treatmentList: treatmentList.zh,
        treatmentDetail: treatmentDetail.zh,
        clinicDetail: clinicDetail.zh,
        chatModal: chatModal.zh,
        myPage: myPage.zh,
        mobileNavigation: mobileNavigation.zh,
        companyInfo: companyInfo.zh,
        resetPw: resetPw.zh,
        paymentModal: paymentModal.zh,
        order: order.zh,
        orderSuccess: orderSuccess.zh,
        termsOfUse: termsOfUse.zh,
        privacyOfPolicy: privacyOfPolicy.zh,
        termsDetail: termsDetail.zh,
        logoutConfirm: logoutConfirm.zh,
        commercialTransactions: commercialTransactions.zh,
        paymentCancelModal: paymentCancelModal.zh,
      },
    },
    ja: {
      translation: {
        headerMain: headerMain.ja,
        footer: footer.ja,
        hospitalLogin: hospitalLogin.ja,
        common: common.ja,
        main: main.ja,
        join: join.ja,
        terms: terms.ja,
        findAccount: findAccount.ja,
        myReservation: myReservation.ja,
        treatmentList: treatmentList.ja,
        treatmentDetail: treatmentDetail.ja,
        clinicDetail: clinicDetail.ja,
        chatModal: chatModal.ja,
        myPage: myPage.ja,
        mobileNavigation: mobileNavigation.ja,
        companyInfo: companyInfo.ja,
        resetPw: resetPw.ja,
        paymentModal: paymentModal.ja,
        order: order.ja,
        orderSuccess: orderSuccess.ja,
        termsOfUse: termsOfUse.ja,
        privacyOfPolicy: privacyOfPolicy.ja,
        termsDetail: termsDetail.ja,
        logoutConfirm: logoutConfirm.ja,
        commercialTransactions: commercialTransactions.ja,
        paymentCancelModal: paymentCancelModal.ja,
      },
    },
    ar: {
      translation: {
        headerMain: headerMain.ar,
        footer: footer.ar,
        hospitalLogin: hospitalLogin.ar,
        common: common.ar,
        main: main.ar,
        join: join.ar,
        terms: terms.ar,
        findAccount: findAccount.ar,
        myReservation: myReservation.ar,
        treatmentList: treatmentList.ar,
        treatmentDetail: treatmentDetail.ar,
        clinicDetail: clinicDetail.ar,
        chatModal: chatModal.ar,
        myPage: myPage.ar,
        mobileNavigation: mobileNavigation.ar,
        companyInfo: companyInfo.ar,
        resetPw: resetPw.ar,
        paymentModal: paymentModal.ar,
        order: order.ar,
        orderSuccess: orderSuccess.ar,
        termsOfUse: termsOfUse.ar,
        privacyOfPolicy: privacyOfPolicy.ar,
        termsDetail: termsDetail.ar,
        logoutConfirm: logoutConfirm.ar,
        commercialTransactions: commercialTransactions.ar,
        paymentCancelModal: paymentCancelModal.ar,
      },
    },
  },
  lng: savedLanguage,
  fallbackLng: "en",
  debug: true,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
